import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import store from '../../../../store';
import withStore from '../../../withStore';
import { RootState, IRootDispatch } from '../../../../store/models';

import NewSRStatsNotification, { NewSearchRankData } from './NewSRStatsNotification';
import {
  useAsyncEffect, useUserState, useIsMobile, useMount,
} from '../../../../hooks';
import { SearchRankStats } from '../../../../store/ProviderSearchRank.model';

type NotificationInfo = {
  showNotification: boolean;
  newSearchRankData?: NewSearchRankData | null;
};

type PageData = {
  loading: boolean;
  eligible: boolean;
  stats: SearchRankStats;
};

export type ActionsTaken = {
  allAppts?: boolean,
  ncdAppts?: boolean,
  reviews?: boolean,
};

export type Notification = {
  type: string;
  provider_id: number;
  creation_time?: number | string | Date;
};

type SearchRankNotificationContainerProps = {
  notification: Notification;
};

export const SearchRankNotificationContainer = ({
  notification,
}: SearchRankNotificationContainerProps) => {
  const [notificationInfo, setNotificationInfo] = useState<NotificationInfo>({
    showNotification: false,
    newSearchRankData: null,
  });
  const isMobile = useIsMobile();
  const dispatch = useDispatch<IRootDispatch>();
  const [actionsTaken, setActionsTaken, actionsTakenLoaded] = useUserState<ActionsTaken>('new-search-rank-stats-notification');
  const { stats, eligible } = useSelector<RootState, PageData>(
    store.select.providerSearchRank.pageData,
  );

  useMount(() => {
    if (!stats) dispatch.providerSearchRank.land();
  });

  useAsyncEffect(async () => {
    const isNewApptAction = !actionsTaken?.allAppts && stats?.clientPayments.raw?.denominator > 0;
    const isNewNcdAction = !actionsTaken?.ncdAppts
      && stats?.newClientPayments.raw?.denominator > 0;
    const isNewPosRevAction = !actionsTaken?.reviews && stats?.reviews.raw?.denominator > 0;
    if (
      isMobile
      && actionsTakenLoaded
      && eligible
      && (isNewApptAction || isNewNcdAction || isNewPosRevAction)
    ) {
      setNotificationInfo({
        showNotification: true,
        newSearchRankData: {
          allAppts: isNewApptAction,
          ncdAppts: isNewNcdAction,
          reviews: isNewPosRevAction,
        },
      });
    }
  }, [actionsTakenLoaded, eligible, stats]);

  const handleCTAClicked = () => {
    const isNewApptAction = !actionsTaken?.allAppts && stats?.clientPayments.raw?.denominator > 0;
    const isNewNcdAction = !actionsTaken?.ncdAppts
      && stats?.newClientPayments.raw?.denominator > 0;
    const isNewPosRevAction = !actionsTaken?.reviews && stats?.reviews.raw?.denominator > 0;

    const currentActions = actionsTaken || {};
    const newActions = {
      ...currentActions,
      allAppts: isNewApptAction,
      ncdAppts: isNewNcdAction,
      reviews: isNewPosRevAction,
    };
    setActionsTaken(newActions);
    setNotificationInfo({ showNotification: false });
  };

  if (!notificationInfo?.showNotification) return null;

  return (
    <NewSRStatsNotification
      notification={notification}
      onCTAClick={handleCTAClicked}
      newSearchRankData={notificationInfo.newSearchRankData}
    />
  );
};

export default withStore(SearchRankNotificationContainer);
